// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum DoorStatus {
  RearDoorOpenSequence = 0,
  DoorOpenSequence = 1,
  GateLock = 2,
  DoorHold = 3
}
